import { ChipButtonContainer, ChipStyled } from "./ChipButton.styles";
import { ChipButtonType } from "./ChipButton.types";

export default function ChipButton({ label, onClick, sx }: ChipButtonType) {
    return (
        <ChipButtonContainer sx={sx}>
            <ChipStyled label={label} onClick={onClick} onTouchEnd={onClick} />
        </ChipButtonContainer>
    );
}
